import PageTemplate from '../containers/common/PageTemplate';

import Container from '../containers/profile';

export default function Profile() {
  return (
    <>
      <PageTemplate>
        <Container />
      </PageTemplate>
    </>
  );
}
